<script>
import { preventDefault } from 'svelte/legacy';
import { lockState } from "@app/store/lockStore.svelte.js";
import {
    projectState
} from '@app/store/projectStore.svelte.js';
import {
    eventGroupState
} from '@app/store/eventGroupStore.svelte.js';
import {
    modalState, hideModal
} from '@app/store/modalStore.svelte.js';
import {
    fade
} from 'svelte/transition';
import * as m from '@app/paraglide/messages.js';
let selectedEventId = $state(eventGroupState[projectState.selected].selected.length > 0 ? eventGroupState[projectState.selected].selected[0]+1 : 0);
let totalEvents = $state(eventGroupState[projectState.selected].events.length);

function selectEvent() {
    //console.log("Going to "+selectedEventId);
    if (selectedEventId <= eventGroupState[projectState.selected].events.length){        try {
            eventGroupState[projectState.selected].selected = [selectedEventId-1];
            const selectedIndex = eventGroupState[projectState.selected].selected[0];
            window.dispatchEvent(new CustomEvent('scrollToVirtualListItem', {
                detail: { index: selectedIndex }
            }));

            if (lockState.video && player){
                player.currentTime = eventGroupState[projectState.selected].events[selectedIndex].start;
            }
        } catch (err) {
            console.log(err.message);
            console.log(err);
        }
    }

    hideModal();
} 

function init(el){
    el.focus()
  }
</script>


<div transition:fade={{duration: 100}} class="modal {modalState.selected === 'goToEvent' ? 'show d-block' : ''}" 
    role="dialog" 
    aria-labelledby="goToEventTitle"
    aria-modal="true"
    tabindex="-1" 
    id="ProjectIncodeModal">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title" id="goToEventTitle">{m.go_to_event()}</h4>
                <button type="button" class="btn-close" aria-label={m.close_dialog()} id="goToEventClose" onclick={hideModal}></button>
            </div>
            <div class="modal-body">
                <form onsubmit={preventDefault(selectEvent)}>
                    <label for="eventIdInput" class="form-label">{m.event_id()}</label>
                    <div class="input-group mb-3" role="group" aria-label={m.event_selection()}>
                        <input type="number" 
                            id="eventIdInput"
                            class="form-control" 
                            placeholder={m.event_id()}
                            aria-label={m.event_number()}
                            aria-describedby="eventIdRange" 
                            step="1" 
                            min="1" 
                            max={totalEvents} 
                            bind:value={selectedEventId} 
                            onfocus={(e)=>{e.target.select()}} 
                            use:init>

                        <span class="input-group-text" id="eventIdRange">/</span>

                        <input type="number" 
                            id="totalEventsInput"
                            class="form-control" 
                            placeholder={m.total_events()}
                            aria-label={m.total_events()}
                            disabled 
                            bind:value={totalEvents}>
                    </div>
                    <button class="btn btn-primary float-end" 
                        id="selectEventBtn"
                        type="submit" 
                        aria-label={m.select_event()}>{m.select_event()}</button>
                </form>
            </div>
        </div>
    </div>
</div>
